/**
 *
 *
 * @export
 * @param {*} userInfo
 * @returns
 */
export function getUserInfo(userInfo) {
  if (userInfo.customerAddresses[0].stateCode === "BA") {
    localStorage.setItem("@UltragazEmpresarial:isBahia", true);
  }
  return {
    type: "GET_USER_INFO",
    userInfo
  };
}

/**
 *
 *
 * @export
 * @param {*} userId
 * @returns
 */
export function handleUserId(userId) {
  return {
    type: "GET_USER_ID",
    userId
  };
}
